module.exports = __webpack_public_path__ + "static/media/smart_saving_img.af11fc7a.png";